import { Box, Typography } from "@mui/material";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import themes from "../../themes/defaultTheme";
import { StyledButton } from "../Header/styles";

export default function Footer({ disableTopMargin = false }) {
  return (
    <Box
      component="footer"
      role="contentinfo"
      aria-label="Site footer"
      sx={{
        backgroundColor: themes.default.palette.primary.light,
        py: 1.5,
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        mt: "auto",
        borderTop: "1px solid",
        borderColor: themes.default.palette.primary.main,
        minHeight: 48,
        ...(!disableTopMargin && { marginTop: 5 })
      }}
    >
      <AccessibilityNewIcon
        fontSize="small"
        aria-hidden="true"
        sx={{ color: themes.default.palette.primary.main, opacity: 0.85 }}
      />
      <Typography
        variant="body2"
        sx={{ color: themes.default.palette.primary.main }}
      >
        For any accessibility questions or concerns, please refer to the{" "}
        <StyledButton
          component="a"
          href=" https://tti.tamu.edu/notices-policies/accessibility-policy/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TTI Accessibility Policy (opens in a new tab)"
          variant="text"
          size="small"
          disableRipple
          sx={{
            verticalAlign: "baseline",
            minWidth: "unset",
            textDecoration: "underline",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
              opacity: 0.75,
            },
            "&:focus-visible": {
              outline: `2px solid ${themes.default.palette.primary.main}`,
              outlineOffset: "2px",
              borderRadius: "2px",
            },
          }}
        >
          TTI Accessibility Policy
        </StyledButton>
      </Typography>
    </Box>
  );
}